import {ComponentStore} from '@ngrx/component-store';
import {PublicReportsPasswordState} from './public-reports';
import {Injectable} from '@angular/core';
import {Observable, of, switchMap, tap} from 'rxjs';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PublicReportsService} from '../../services/public-reports.service';
import {ActivatedRoute, Router} from '@angular/router';
import {catchError} from 'rxjs/operators';

@Injectable()
export class PublicReportsPasswordStore extends ComponentStore<PublicReportsPasswordState> {
  public readonly form: FormGroup<{
    password: FormControl<string>
  }> = new FormGroup({
    password: new FormControl(null, [Validators.required])
  });

  public readonly loading$: Observable<boolean> = this.select((state: PublicReportsPasswordState): boolean => state.loading);
  public readonly errors$: Observable<Array<string>> = this.select((state: PublicReportsPasswordState): Array<string> => state.errors);

  public readonly checkPassword: () => void = this.effect((params$: Observable<void>): Observable<{ authentication_code: string }> => params$.pipe(
    tap((): void => {
      this.form.disable();

      this.patchState({
        loading: true,
        errors: [],
      });
    }),
    switchMap(() => this._service.checkSavedReportPassword(this._route.snapshot.params.uuid, this.form.value.password).pipe(
      tap((response: { authentication_code: string }): void => {
        //redirect
        this._router.navigate(
          ['public-reports', 'report'],
          {
            state: {
              uuid: this._route.snapshot.params.uuid,
              token: response.authentication_code
            }
          }
        );
      }),
      catchError((err: any, caught: Observable<any>): Observable<any> => {
        this.form.enable();

        this.patchState({
          loading: false,
          errors: ['Invalid password, try again !']
        });

        return of();
      })
    ))
  ));

  constructor(
    private readonly _service: PublicReportsService,
    private readonly _route: ActivatedRoute,
    private readonly _router: Router
  ) {
    super({
      loading: false,
      errors: null
    });
  }

}
